import React, { useState, useMemo, useCallback } from 'react';
import classNames from 'classnames';
import { Drawer } from '@mui/material';
import { MenuOpen as MenuOpenIcon } from '@mui/icons-material';
import UserSettings from './UserSettings';
import KorioSVG from 'assets/korio.svg';
import AllStudiesSVG from 'assets/studies.svg';
import './styles.scss';

const NavigationPanel = () => {
  const [isOpen, setIsOpen] = useState(true);

  const toggle = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  const classes = useMemo(() => {
    return classNames({
      collapsed: !isOpen,
    }, 'navigation-panel');
  }, [isOpen]);

  return (
    <Drawer
      className={classes}
      variant="permanent">
      <header>
        <img className="app-logo" src={KorioSVG} />

        <div
          className="toggle-button"
          onClick={toggle}>
          <MenuOpenIcon />
        </div>
      </header>

      <section>
        <ul>
          <li>
            <a href="/" className="active">
              <div><img src={AllStudiesSVG} /></div>
              <div>Studies</div>
            </a>
          </li>
        </ul>
      </section>

      <footer>
        <UserSettings isCollapsed={!isOpen} />
      </footer>
    </Drawer>
  );
};

export default NavigationPanel;
